// asyncronous, gaan we gebruiken om naar de api te gaan

import {
  api,
} from '@/utils';

import CITY_ACTION_TYPES from './city.action-types';
import CITY_MUTATION_TYPES from './city.mutation-types';

const CITY_ACTIONS = {
  [CITY_ACTION_TYPES.FETCH_DATA_CITIES]({
    commit,
  }) {
    return new Promise((resolve, reject) => {
      api.get('searchgarage/getallcities')
        .then((response) => {
          if (response.data != null) {
            commit(CITY_MUTATION_TYPES.APPEND_CITIES, response.data);
          }

          resolve();
        })
        .catch((error) => {
          commit(CITY_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
};

export default CITY_ACTIONS;
